import axios from 'axios';
import md5 from 'js-md5';
import Cookies from 'js-cookie';
import { Message } from 'element-ui';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';
// let base = 'http://mapi.dxx2xxn.cn';
let base = 'https://mapi.dxx2xxn.cn';
// let base = 'http://localhost:8081';
// let base = 'http://192.168.1.3:8081';

const getSignStr = function(obj,token,timestamp){
  let values = ''
  obj && Object.keys(obj).sort().forEach(key => {
    const value = obj[key]
    values += value === null || value === undefined ? 'null' : obj[key]
  })
  return values + token + timestamp
}

const getSign = function(obj,token,timestamp){
  const signStr = getSignStr(obj,token,timestamp)
  return md5(signStr)
}

// request拦截器
axios.interceptors.request.use(config => {
	const timestamp = new Date().getTime()
	let cookie = Cookies.get('user_info');
	if(cookie){
		cookie = JSON.parse(cookie);
		config.headers = {
	      'Content-Type': 'application/json;charset=UTF-8', // 设置很关键
	      'tm': timestamp,
	      's': cookie.session,
	      't': getSign(config.method=='post'? {} : config.params, cookie.token, timestamp)
	    }
	}
	return config;
}, error => {
	console.log(error); // for debug
	Promise.reject(error);
})

axios.interceptors.response.use(
  response => {
  	 const res = response.data;
      if (res.code == 410) {
        Message({
          message: res.message,
          type: 'error'
        });
      } else {
        return response;
      }
  },
    
  error => {
    console.log('err' + error);// for debug
    if (error.response.status == 410 || error.response.status == 401) {
        Message({
          message: '请重新登录',
          type: 'error',
          duration: 3 * 1000
        });
        window.location.href="/#/login"
      }else{
        Message({
          message: '获取数据失败，请刷新重试',
          type: 'error',
          duration: 3 * 1000
        });
      }

    return Promise.reject(error);
  }
)


//rsa
export const getRsa = params => { return axios.get(`${base}/auth/rsa`, { params: params }); };

// //用户组
// export const editUserGroup = params => { return axios.post(`${base}/user/group/update`, params); };
// export const getUserGroupDetail = params => { return axios.get(`${base}/user/group/detail`, { params: params }); };

//用户
export const getUserList = params => { return axios.get(`${base}/user/list`, { params: params }); };

export const addUser = params => { return axios.post(`${base}/user/add`, params); };

export const editUser = params => { return axios.post(`${base}/user/update`, params); };

export const editPassword = params => { return axios.post(`${base}/user/password`, params); };

export const resetPwd = params => { return axios.post(`${base}/user/resetPwd`, params); };


//登陆
export const login = params => { return axios.post(`${base}/auth/login`, params); };

export const requestLogin = params => { return axios.post(`/login`, params).then(res => res.data); };


//商品
export const getGoodsList = params => { return axios.get(`${base}/goods/list`, { params: params }); };

export const addGoods = params => { return axios.post(`${base}/goods/add`, params); };

export const batAddGoods = params => { return axios.post(`${base}/goods/batAdd`, params); };

export const editGoods = params => { return axios.post(`${base}/goods/update`, params); };

export const getGoodsPriceAdvice = params => { return axios.get(`${base}/goods/advice`, { params: params }); };

export const getGoodsPriceAdviceList = params => { return axios.get(`${base}/goods/advice/list`, { params: params }); };

export const getOrdersByGoodsId = params => { return axios.get(`${base}/goods/orders`, { params: params }); };

//获取最近进货列表
export const getRecentGoodsList = params => { return axios.get(`${base}/goods/recent`, { params: params }); };

//入库
export const getStockList = params => { return axios.get(`${base}/stock/list`, { params: params }); };

export const addStock = params => { return axios.post(`${base}/stock/add`, params); };

export const editStock = params => { return axios.post(`${base}/stock/update`, params); };

export const delStock = params => { return axios.post(`${base}/stock/delete`, params); };

export const getStockDetail = params => { return axios.get(`${base}/stock/detail`, { params: params }); };


//需求公司
export const getDemanderList = params => { return axios.get(`${base}/demander/list`, { params: params }); };

export const addDemander = params => { return axios.post(`${base}/demander/add`, params); };

export const editDemander = params => { return axios.post(`${base}/demander/update`, params); };

//公司
export const getProviderList = params => { return axios.get(`${base}/provider/list`, { params: params }); };

export const addProvider = params => { return axios.post(`${base}/provider/add`, params); };

export const editProvider = params => { return axios.post(`${base}/provider/update`, params); };

//订单
export const getOrderList = params => { return axios.get(`${base}/order/list`, { params: params }); };

export const getOrderListExport = params => { return axios.get(`${base}/order/list/export`, { params: params }); };

export const getOrderListCheck = params => { return axios.get(`${base}/order/list/check`, { params: params }); };

export const addOrder = params => { return axios.post(`${base}/order/add`, params); };

export const editOrder = params => { return axios.post(`${base}/order/update`, params); };

export const delOrder = params => { return axios.post(`${base}/order/delete`, params); };

export const getOrderDetail = params => { return axios.get(`${base}/order/detail`, { params: params }); };


//订单结算
export const getCheckList = params => { return axios.get(`${base}/check/list`, { params: params }); };

export const addCheck = params => { return axios.post(`${base}/check/add`, params); };

//更新订单相关商品
export const addOrderDetail = params => { return axios.post(`${base}/order/detail/add`, params); };

export const editOrderDetail = params => { return axios.post(`${base}/order/detail/edit`, params); };

export const delOrderDetail = params => { return axios.post(`${base}/order/detail/del`, params); };


//上传物料图片
export const fileGoodsUpload = params => { return axios.post(`${base}/file/goods/upload`, params); };


